export const colors = {
  primaryColor : "#00deff",
  secondaryColor : "#161616",
  textWithWhiteBg : "#181818",
  textWithPrimaryColorBg : "#181818",
  linearGradient :
"linear-gradient(107deg, rgba(0, 0, 0, 0.60) -2.13%, rgba(0, 0, 0, 0.60) 35.42%, rgba(0, 222, 255, 0.60) 77.97%, rgba(0, 222, 255, 0.60) 125.13%)",
darkColor:"#04b8d3"
}